/**
 * SummaryContent Container
 *
 * Container component for displaying AI-generated player summary content.
 * @remarks
 * This component is simple and primarily passes through props, but follows the
 * Container/View pattern for consistency with other components.
 */

import SummaryContentView from "./SummaryContentView";

/**
 * Props interface for SummaryContent container component
 */
interface SummaryContentContainerProps {
  testID?: string;
  summaryContent: string;
  isSmallScreen: boolean;
  isDark: boolean;
}

/**
 * Container component for summary content
 * @param props - Component props
 * @param props.testID - Test ID for the component
 * @param props.summaryContent - The summary text content to display
 * @param props.isSmallScreen - Whether the screen is small
 * @param props.isDark - Whether dark theme is active
 */
function SummaryContentContainer({
  testID,
  summaryContent,
  isSmallScreen: _isSmallScreen,
  isDark,
}: SummaryContentContainerProps) {
  return (
    <SummaryContentView
      testID={testID}
      summaryContent={summaryContent}
      isDark={isDark}
    />
  );
}

export default SummaryContentContainer;
